import { Phone, MapPin } from "lucide-react";
import { BRAND } from "@/lib/store";

const Footer = () => {
  return (
    <footer id="footer" className="bg-[var(--bg)]">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-20 md:py-28">
        <h2 className="font-anton uppercase text-[16vw] md:text-[11vw] leading-[0.8] tracking-tighter">
          Full Send<span className="text-[var(--accent)]">.</span>
        </h2>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-[var(--line)] pt-12">
          <div>
            <p className="uppercase tracking-widest text-xs text-[var(--text-dim)] mb-4">Studio</p>
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 mt-0.5 text-[var(--accent)]" />
              <p className="text-lg">{BRAND.location}</p>
            </div>
          </div>
          <div>
            <p className="uppercase tracking-widest text-xs text-[var(--text-dim)] mb-4">Order / Enquiries</p>
            <div className="space-y-2">
              {BRAND.phones.map((p) => (
                <a
                  key={p}
                  href={`tel:${p.replace(/\s/g, "")}`}
                  data-testid={`footer-phone-${p.replace(/\s/g, "")}`}
                  className="flex items-center gap-3 text-lg hover:text-[var(--accent)] transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  {p}
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="uppercase tracking-widest text-xs text-[var(--text-dim)] mb-4">The Drop</p>
            <p className="text-lg text-[var(--text-dim)]">
              Tees & long sleeves — Black / Navy / Red.<br />From 1500 KSH. Order here, complete on Instagram.
            </p>
          </div>
        </div>
        <div className="mt-16 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-widest text-[var(--text-dim)]">
          <span>© {new Date().getFullYear()} {BRAND.name}</span>
          <span>Made in Nairobi, Kenya</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
